export default {
  LOG_IN: {
    url: 'auth/login',
    method: 'POST'
  },
  LOG_OUT: {
    url: 'auth/logout',
    method: 'GET'
  },
  REGISTER: {
    url: '/auth/register',
    method: 'POST'
  },
  GET_AUTH_INFO: {
    url: '/auth/info',
    method: 'GET'
  },
  LOGIN_OTP: {
    url: '/auth/otp-login',
    method: 'POST'
  }
};
